import { redirect } from "@tanstack/react-router";
import { authClient } from "./auth-client";

/**
 * Single-user app: no session yet means "app hasn't auto-logged in as the
 * seeded admin," not "go show a login screen." A thrown fetch here means the
 * device is offline (post-first-load, e.g. a PWA deep link) — that must NOT
 * force a /login redirect, since the cached shell should render with an
 * offline banner instead. Only a genuine "no session AND auto-login itself
 * failed" (DB down, seed never ran) falls through to /login.
 */
export async function requireAuth() {
  let session = await authClient.getSession();
  if (!session.data) {
    let autoLoginOk = false;
    try {
      const res = await fetch("/api/auth/auto-login", { method: "POST" });
      autoLoginOk = res.ok;
    } catch {
      // Offline or the server is unreachable — let the cached shell render.
      return null;
    }
    if (autoLoginOk) {
      session = await authClient.getSession();
    }
  }
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}
